import { useState, useEffect } from 'react';
import { Form990Data } from '../types/form990.types';

interface Form990History {
  id: string;
  taxYear: string;
  status: string;
  submittedDate?: string;
  signedBy?: string;
  pdfUrl?: string;
}

export const useForm990History = () => {
  const [history, setHistory] = useState<Form990History[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      // Fetch from your API
      const response = await fetch('/api/form990/history');
      const data = await response.json();
      setHistory(data);
    } catch (error) {
      console.error('Error fetching 990 history:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadPDF = async (formId: string) => {
    try {
      const response = await fetch(`/api/form990/${formId}/pdf`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `form990_${formId}.pdf`;
      a.click();
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return {
    history,
    isLoading,
    downloadPDF,
    refreshHistory: fetchHistory
  };
}; 